<template>
    <span>
    <v-chip close small class="ml-2" v-if="catalogo"
            @click:close="onCloseCatalogo()">
      Catálogo: {{ catalogo.nome }}
    </v-chip>
  </span>
</template>

<script>
export default {
  computed: {
    catalogo: {
      get() {
        return this.$store.getters['listagemOfertas/catalogo'];
      },
      set(catalogo) {
        this.$store.dispatch('listagemOfertas/catalogo', catalogo);
      },
    },
  },
  methods: {
    onCloseCatalogo() {
      this.catalogo = null;
      this.$emit('change');
    },
  },
};
</script>
